var acc = document.getElementsByClassName("tab-title");
var i;

for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
        } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
        }
    });
}

var accactive = document.querySelector(".tab-title.active");
if (accactive) {
    var panelactive = accactive.nextElementSibling;
    if (panelactive.style.maxHeight) {
        panelactive.style.maxHeight = null;
    } else {
        panelactive.style.maxHeight = panelactive.scrollHeight + "px";
    }
}

document.querySelectorAll("#process-steps-diagram .process-step-icon-image").forEach(function (step, index) {
    step.addEventListener("click", function () {
        var id = this.getAttribute("data-step");
        var activebtn = this.closest('#process-steps-diagram').querySelector(".process-step-icon-image.active");
        activebtn ? activebtn.classList.remove("active") : "";
        this.classList.add("active");

        if (screen.width < 990) {
            goToSlide(index)
        } else {
            var processstep = document.querySelector("#process-steps");
            processstep.querySelector("#process-step__" + id).classList.add("active");
            processstep.classList.add("active");
        }
    });
})

document.querySelectorAll(".process-steps__close").forEach(function (btn) {
    btn.addEventListener("click", function () {
        var processstep = document.querySelector("#process-steps");
        processstep.classList.remove("active");
        document.querySelector(".process-step.active").classList.remove("active");
    })
})

if (document.querySelectorAll("#process-steps-diagram .process-step-icon-image").length) {
    var loop = 1;
    var nextloop = 1;
    var side = 'next';
    setInterval(() => {
        if (screen.width < 990) {
            document.querySelectorAll("#process-steps-diagram .process-step-icon-image")[loop].click();
            if (document.querySelectorAll("#process-steps-diagram .process-step-icon-image").length - 2 == loop && side == 'next') {
                nextloop = -1;
                side = 'prev'
            }

            if (loop == 0 && side == 'prev') {
                nextloop = 1;
                side = 'next';
            }

            loop = loop + nextloop;
            console.log(loop, nextloop, side)
        }
    }, 5000);
}

 document.addEventListener('change', function (event) {
    const checkbox = event.target;
    
    if (checkbox.matches('.custom-checkbox')) {
      const planId = checkbox.getAttribute('data-plan-id');
      const form = checkbox.closest('form');
      if (!form) return;

      // Remove existing selling_plan input if it exists
      const existingInput = form.querySelector('input[name="selling_plan"]');
      if (existingInput) {
        existingInput.remove();
      }

      // If checkbox is checked, add hidden input
      if (checkbox.checked) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'selling_plan';
        input.value = planId;
        form.appendChild(input);
      }
    }
  });

  // Also initialize on page load for any that are pre-checked
  document.addEventListener('DOMContentLoaded', function () {
    const checkboxes = document.querySelectorAll('.custom-checkbox');
    checkboxes.forEach(function (checkbox) {
      if (checkbox.checked) {
        checkbox.dispatchEvent(new Event('change'));
      }
    });
  });

